import AdminToolsLayout from './AdminToolsLayout';

export default AdminToolsLayout;
